import * as React from 'react';
import { useAuthStore } from '@/store/useAuthStore';
import {
  hasRequiredActionsPermissions,
  hasRequiredActionsRoles,
} from '@/utils/authUtils';

export default function useEnforceAccessControl({
  requiredRoles = [],
  requiredPermissions = [],
  bypassAuthCheck = false,
}) {
  const user = useAuthStore((state) => state.user);

  // * User roles
  const roles = React.useMemo(() => {
    return user?.roles || [];
  }, [user?.roles]);

  // * User permissions
  const permissions = React.useMemo(() => {
    return user?.permissions || [];
  }, [user?.permissions]);

  // * User roles and permissions should be arrays
  const checkAccess = React.useMemo(() => {
    // Check if user roles are an array
    const hasRoles = hasRequiredActionsRoles(roles, requiredRoles);

    // Check if user permissions are an array
    const hasPermissions = hasRequiredActionsPermissions(
      permissions,
      requiredPermissions
    );

    // console.info(
    //   '🚀 DEBUG HAS-ROLES',
    //   { roles, requiredRoles },
    //   '===',
    //   hasRoles
    // );

    // console.info(
    //   '🚀 DEBUG HAS PERMISSIONS',
    //   { permissions, requiredPermissions },
    //   '===',
    //   hasPermissions
    // );

    return hasRoles && hasPermissions;
  }, [requiredPermissions, requiredRoles, permissions, roles]);

  if (!user) {
    return false;
  }

  if (roles && !Array.isArray(roles)) {
    console.warn('user roles should be an array');
  }

  if (permissions && !Array.isArray(permissions)) {
    console.warn('user permissions should be an array');
  }

  if (!Array.isArray(requiredRoles)) {
    console.warn('Required roles should be an array. Received:', requiredRoles);
  }

  if (!Array.isArray(requiredPermissions)) {
    console.warn(
      'Required permissions should be an array. Received:',
      requiredPermissions
    );
  }

  if (!bypassAuthCheck && !checkAccess) {
    return false;
  }

  return true;
}
